import { render, staticRenderFns } from "./CorrespondenceItemCompose.vue?vue&type=template&id=c8290422"
import script from "./CorrespondenceItemCompose.vue?vue&type=script&lang=js"
export * from "./CorrespondenceItemCompose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports